module.exports = __webpack_public_path__ + "static/kazandiran-trafik-9cd4cb248b61594ace0826884ea665d5.jpg";